<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <search-payment :show.sync="showFilterPop" :type="'channel'" @handlequery="handleFqueryFilter" />
    <add-btn v-hasPermi="['cont:newIncome:add']" @add="handleAddPayment" />
    <van-tabs v-model="active" @change="handleClick">
      <van-tab name="0" title="全部" :badge="countItem.allCount != 0?countItem.allCount:''"></van-tab>
      <van-tab name="1" title="公海" :badge="countItem.seaCount != 0?countItem.seaCount:''"></van-tab>
      <van-tab name="2" title="未发送" :badge="countItem.nogetCount != 0?countItem.nogetCount:''"></van-tab>
      <van-tab name="3" title="部分发送" :badge="countItem.noconfirmCount != 0?countItem.noconfirmCount:''"></van-tab>
      <van-tab name="4" title="已发送" :badge="countItem.getCount != 0?countItem.getCount:''"></van-tab>
      <!-- <van-tab name="5" title="需求异常" :badge="countItem.errorCount != 0?countItem.errorCount:''"></van-tab> -->
    </van-tabs>
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="onLoad" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item, index) in list" :key="index" @click="toDetails(item)" >
        <!-- <div style="display: flex; align-items: center; height:100%; width:100%"> -->
          <!-- <div style="flex: 1;"> -->
            <div class="custName-wrap" style="padding: 0;">
              <div class="custName">
                {{item.custName}}<van-tag plain :type="typeArr[item.checkStatus]" style="margin-left: 10px;">{{statusArr[item.checkStatus]}}</van-tag>
              </div>
            </div>
            <div style="font-size: 12px">
              <span style="color: #ff976a;">需求:{{item.payMoney}}(元)</span>
              <span style="color: #07c160;margin-left: 5px">已发送:{{item.confirmMoney || '0'}}(元)</span>
            </div>
            <div style="font-size: 12px">
              <span style="color: #ee0a24;">可发送:{{item.noConfirmMoney || '0'}}(元)</span>
              <span style="color: #ee0a24;margin-left: 5px">待确认:{{item.totalMoney || '0'}}(元)</span>
            </div>
            <div style="color: #333; font-size: 12px">{{item.payBank}} 账号: {{item.payBankAccountNo}}</div>
            <div style="color: #999; font-size: 12px">对应业务员:{{item.userName}}</div>
            <div style="color: #999; font-size: 12px">需求日期:{{item.payDate}}</div>
            <div style="color: #999; font-size: 12px">{{item.createBy +'  ' + item.createTime}}</div>
            <div style="color: #999; font-size: 12px" v-if="item.execCustomerNames">执行客户:{{item.execCustomerNames}}</div>
          <!-- </div> -->
          <!-- <van-icon style="flex:0.1;" color="#c1c1c1" name="arrow" size="16" class="arrow-color" /> -->
        <!-- </div> -->
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
  </div>
</template>

<script>
// import payment from '@/api/cont/payment'
import channel from '@/api/channel/channel'
// import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import SearchPayment from '@/views/cont/payment/Search.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import { Toast, Tab, Tabs, DatetimePicker } from 'vant'
import AddBtn from '@/components/common/AddBtn'

export default {
  name: 'approve',
  components: {
    AddBtn,
    SearchComponent,
    SearchPayment,
    EmptyComponent,
    TotalComponent,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast
  },
  data() {
    return {
      add_show: false,
      isEmpty: false,
      active: 0,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      countItem: {},
      showFilterPop: false,
      custList: [],
      paymentFormShow: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        checkStatus: null,
        companyId: null,
        // bankType: 1,
        teamName: null,
        scrollTop: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      statusArr: ['', '需求公海', '需求未发送', '需求部分发送', '需求已发送', '需求异常'],
      typeArr: ['', 'danger', 'danger', 'warning', 'success', 'primary']
    }
  },
  created() {

  },
  async mounted() {
    // 存在 读缓存
    if (sessionStorage.getItem('paymentSearch')) {
      this.queryParams = JSON.parse(sessionStorage.getItem('paymentQuery'))
      this.queryParams.pageSize = this.queryParams.pageNum * 10
      this.queryParams.pageNum = 1
      document.documentElement.scrollTop = this.queryParams.scrollTop
      this.active = this.queryParams.checkStatus
    } else {
      sessionStorage.removeItem('paymentQuery')
    }
    if (this.$route.query.active) {
      this.active = this.$route.query.active
      this.queryParams.checkStatus = this.$route.query.active
    }
    await this.handleList()
    await this.getCountItem()
    await this.init()
    if (sessionStorage.getItem('paymentSearch')) {
      document.documentElement.scrollTop = this.queryParams.scrollTop
    }
  },
  destroyed() {
    // 销毁组件
    sessionStorage.removeItem('paymentSearch')
    // sessionStorage.removeItem('paymentQuery')
  },
  methods: {
    async init() {
      document.title = '需求发送'
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.queryParams.teamName = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
      this.showFilterPop = false
    },
    queryCustList() {
      sessionStorage.removeItem('paymentSearch')
      sessionStorage.removeItem('paymentQuery')
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
      this.getCountItem()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    toDetails(item) {
      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      this.queryParams.scrollTop = scrollTop
      sessionStorage.setItem('paymentQuery', JSON.stringify(this.queryParams))
      this.$router.push({
        path: '/cont/payment/paymentDetail',
        query: { id: item.needId, active: this.active, type: 'channel' }
      })
    },
    async handleList() {
      this.loading = true
      const res = await channel.listNewIncome(this.queryParams)
      if (res.code === 200) {
        console.log(res)
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        if (this.queryParams.pageSize > 10 && this.queryParams.pageNum == 1) {
          this.queryParams.pageNum = this.queryParams.pageSize / 10
          this.queryParams.pageSize = 10
        }
        this.queryParams.pageNum += 1
        this.total = res.total
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    // 查询打款记录数量
    getCountItem() {
      // this.queryParams.checkStatus = null
      channel.newIncomeCount({ ...this.queryParams, checkStatus: null }).then(res => {
        if (res.code === 200) {
          this.countItem = res.data
        }
      })
    },
    onLoad() {
      this.handleList()
      this.getCountItem()
    },
    handleClick(tab, event) {
      if (tab == '0') {
        this.queryParams.checkStatus = null
      } else {
        this.queryParams.checkStatus = tab
      }
      this.queryCustList()
    },
    handleAddPayment() {
      // this.paymentVisible = true
      sessionStorage.removeItem('paymentSearch')
      this.$router.push({
        path: '/cont/payment/addPayment'
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .2rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
.cust /deep/.van-dialog__content {
  padding: 0 20px;
}
</style>
